<template>
  <div>
    <NotFound
      type="ok"
      title="Publicar"
      text="Esta alocação estará pública na página do centro. Atenção: A alocação do centro será substituída por esta."
    >
      <v-btn color="primary" :loading="loading" @click="handlePublicar">publicar</v-btn>
    </NotFound>
  </div>
</template>

<script>
import { publicSolution } from "@/api/paas/center";
import NotFound from "@/components/NotFound.vue";

export default {
  name: "HandlePublicPlan",
  props: {
    plan: Object
  },
  data() {
    return {
      loading: false
    };
  },
  components: {
    NotFound
  },
  methods: {
    handlePublicar() {
      this.loading = true;
      publicSolution(this.plan?.id)
        .then(() => {
          this.$router.push({ path: "/paas/centro" });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
